<template>
	<div class="product-page">
		<div class="container">
			<table class="match-table">
				<thead>
					<tr>
						<th class="checkbox-col" style="text-align: center;">
							<el-checkbox v-model="selectAll" @change="handleSelectAll"></el-checkbox>
						</th>
						<th class="index-col" style="text-align: center;">{{ $t('serialNumber') }}</th>
						<th class="upload-image-col">{{ $t('productImage') }}</th>
						<th class="match-result-col">{{ $t('matchedProducts') }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="uploadedImages.length == 0">
						<td :colspan="4" style="height: 68vh;padding: 0;">
							<div class="nodata" style="margin-top: 80px;">
								<img src="/icon/common/icon-search.png" style="width: auto;height: 150px;">
								<span>{{$t('uploadImageSearch')}}</span>
							</div>
						</td>
					</tr>
					<tr v-else v-for="(item, index) in uploadedImages" :key="index">
						<td class="checkbox-col" style="text-align: center;">
							<el-checkbox v-model="item.checked"></el-checkbox>
						</td>
						<td class="index-col" style="text-align: center;">{{ index + 1 }}</td>
						<td class="upload-image-col">
							<div class="uploaded-image-item">
								<img :src="item.isSetting ? item.base64 : item.url" alt="Uploaded Image"
									class="uploaded-image">
								<!-- 搜索状态遮罩层 -->
								<div v-if="item.loadingStatus === 'waiting'" class="search-mask waiting">
									<div class="search-mask-content">
										<i class="el-icon-loading el-icon--right"></i>
										<span>{{ $t('waitingRecognition') }}</span>
									</div>
								</div>
								<div v-if="item.loadingStatus === 'searching'" class="search-mask searching">
									<div class="scan-line"></div>
									<div class="search-mask-content">
										<span>{{ $t('recognizingSearching') }}</span>
									</div>
								</div>
							</div>
						</td>
						<td class="match-result-col">
							<div class="match-item loading" v-if="!item.goods" style="background: transparent;">
								<div class="loading-container">
									<div class="loading-spinner"></div>
									<span style="color: #999;">{{$t('waitingSearchResult')}}</span>
								</div>
							</div>
							<div class="match-item" v-if="item.goods">
								<div class="match-header">
									<img src="/icon/product/similar.svg" alt="">
									<span class="match-label">{{ $t('foundSimilarSource') }}</span>
									<el-button type="danger" size="mini" class="view-all-btn" @click="showMore(item)">
										{{ $t('viewAll') }} <i class="el-icon-arrow-right"></i>
									</el-button>
								</div>
								<div class="match-content" @click="handleGoodsInfo(item.goods)">
									<div class="match-image-container">
										<img :src="item.goods.small" class="match-image">
									</div>
									<div class="match-info">
										<div class="vip-tag">
											<div class="vip-tag-left">
												<img src="/icon/common/vip.svg" style="width: 15px;">
												VIP1
											</div>
											<div class="store-name">
												{{item.goods.storeName}}
											</div>
										</div>

										<div class="product-name">
											{{item.goods.goodsName}}
										</div>
										<div class="product-price">
											<span>{{currencySymbol}}</span>
											<span style="margin-left: 3px;">{{ item.goods.price }}</span>
										</div>
									</div>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="container submit-layout" :class="{'submit-layout-fixed':!isSubmitSticky}">
			<div class="submit-left">
				<el-checkbox v-model="selectAll" @change="handleSelectAll">{{ $t('selectAll') }}</el-checkbox>
				<div style="margin-left: 20px;color: #D9001B;cursor: pointer;" @click="deleteSelectImage">
					{{$t('delete')}}</div>
			</div>
			<div class="submit-right">
				<div class="submit-sub-right">
					<span class="btn-top-tip">{{ $t('canUploadImages') }}
						<span> {{ uploadedImagesCount }}/{{ maxImages }}</span>
					</span>
					<div class="upload-button">
						<el-button @click="triggerFileInput" type="danger"
							class="upload-btn">{{ $t('againUploadImage') }}</el-button>
						<input type="file" ref="fileInput" class="file-input" accept="image/*" multiple
							@change="handleFileUpload">
					</div>
				</div>
				<div class="submit-sub-right">
					<span class="btn-top-tip">{{ $t('selectedItems') }}
						<span style="color: #D9001B;">{{ selectedCount }}</span>
						{{ $t('products') }}</span>
					<el-button type="primary" class="add-cart-btn">{{ $t('addToCart') }}</el-button>
				</div>
			</div>
		</div>

		<!-- 查看更多窗口 -->
		<el-dialog :title="$t('allSourceGoods')" :visible.sync="showMoreProduct" width="1200px" top="1vh" center
			class="custom-dialog" @close="handleClose">

			<div ref="dialogLayout" class="dialog-layout">
				<div style="display: flex;">
					<div class="uploaded-image-item">
						<img :src="selectImage.isSetting ? selectImage.newBase64 : selectImage.url" alt="Uploaded Image"
							class="uploaded-image">
						<button class="remove-image-btn" @click.stop="removeImage(selectImage.key)">
							<i class="el-icon-close"></i>
						</button>
						<div class="manual-select" @click="setManualSelect(selectImage)">{{ $t('manualSelect') }}</div>
						<!-- 搜索状态遮罩层 -->
						<div v-if="selectImage.loadingStatus === 'waiting'" class="search-mask waiting">
							<div class="search-mask-content">
								<i class="el-icon-loading el-icon--right"></i>
								<span>{{ $t('waitingRecognition') }}</span>
							</div>
						</div>
						<div v-if="selectImage.loadingStatus === 'searching'" class="search-mask searching">
							<div class="scan-line"></div>
							<div class="search-mask-content">
								<span>{{ $t('recognizingSearching') }}</span>
							</div>
						</div>
					</div>
					<div class="small-image-container">
						<div v-for="item in smallImageList" :key="item.id" class="small-image-item"
							@click="handleSmallImage(item)">
							<img :src="item.base64" style="width: 100px;height: 100px;border-radius: 8px;"
								:style="{'border':item.checked?'2px solid #D9001B':'0'}">
						</div>
					</div>
				</div>
				<!-- 当前选择区域 -->
				<div class="match-content match-content-selected">
					<div class="nowed-selected">{{ $t('currentSelection') }}</div>
					<div class="match-image-container">
						<img :src="selectGoods.small" class="match-image">
					</div>
					<div class="match-info">
						<div class="vip-tag">
							<div class="vip-tag-left">
								<img src="/icon/common/vip.svg" style="width: 15px;">
								VIP1
							</div>
							<div class="store-name">{{selectGoods.storeName}}</div>
						</div>

						<div class="product-name">{{selectGoods.goodsName}}</div>
						<div class="product-price">
							<span>{{currencySymbol}}</span>
							<span style="margin-left: 3px;">{{ selectGoods.price }}</span>
						</div>
					</div>
				</div>
				<!-- 查询条件区域 -->
				<div>
					<ProductSearchFilter ref="productSearchFilter" module="product" :platform-id="platform" />
				</div>
				<!-- 图片搜索结果商品列表 -->
				<div style="margin-top: 30px;">
					<ProductListForImage :goods="selectImage.goodsList" :loading="searchStatus"
						:select-index="selectImage.goodsIndex" :is-show-buy="true" @select-goods="selectGoodsIndex" />
					<div style="display: flex;justify-content: center;">
						<div v-if="loadingMore&&selectImage.loadingStatus=='completed'" class="loading-more"
							style="margin: 30px 0; text-align: center;">
							<i class="el-icon-loading"></i>
							<span>{{$t('dataLoading')}}</span>
						</div>
					</div>
					<div class="dialog-top" @click="handleTop">
						<i class="el-icon-caret-top" style="font-size: 20px;"></i>
						<span>{{ $t('top') }}</span>
					</div>
				</div>
			</div>
		</el-dialog>

		<!-- 引入选择搜索区域组件 -->
		<SelectImageSearchArea :visible.sync="dialogVisible" :select-image="selectImage"
			@confirm="handleSelectionConfirm" @cancel="handleSelectionCancel" />
		<RightFixedPanel @openEnquiry="enquiryDialogVisible = true" @openComplaint="complaintDialogVisible = true" />
		<EnquiryDialog :visible.sync="enquiryDialogVisible" />

		<ComplaintDialog :visible.sync="complaintDialogVisible" />
	</div>
</template>

<script>
	import storage from "@/utils/storage.js";
	import ProductListForImage from '@/components/ProductListForImage.vue';
	import ProductSearchFilter from '@/components/ProductSearchFilter.vue'
	import SelectImageSearchArea from '@/components/SelectImageSearchArea.vue'
	import RightFixedPanel from '@/components/RightFixedPanel.vue';
	import EnquiryDialog from '@/components/EnquiryDialog.vue';
	import ComplaintDialog from '@/components/ComplaintDialog.vue';
	import goodsApi from '@/api/product';
	import {
		generateSmallImages,
		generateThumbnail
	} from '@/utils/searchImage';
	export default {
		name: 'ProductSearchByMoreImage',
		components: {
			ProductListForImage,
			SelectImageSearchArea,
			ProductSearchFilter,
			RightFixedPanel,
			EnquiryDialog,
			ComplaintDialog
		},
		data() {
			return {
				enquiryDialogVisible: false,
				complaintDialogVisible: false,
				currencySymbol: '',
				// 查询条件
				sortBy: 'default',
				platform: 'all',
				priceRange: 'all',
				brand: 'all',
				shipping: 'all',
				showMoreProduct: false,
				selectAll: false,
				uploadedImagesCount: 0,
				maxImages: 50,
				isSubmitSticky: true,
				matchTableHeight: 0,
				// 图片选择相关
				dialogVisible: false, //显示设置搜索区域弹窗
				selectImage: {}, //需要设置搜索区域的图片信息
				selectGoods: {},
				// 搜索流程控制
				isSearching: false,
				searchStatus: 'waiting',
				// 搜索结果存储，使用key作为唯一键值
				searchResults: {},
				// 上传的图片
				uploadedImages: [],
				// 搜索结果商品列表
				imageSearchProducts: [],
				// 小图片列表
				smallImageList: [],
				// 原始图片尺寸
				originalW: 0,
				originalH: 0,
				canvasImage: null,
				minSelectionSize: 50,
				loadingMore: false,
			}
		},
		computed: {
			selectedCount() {
				return this.uploadedImages.filter(item => item.checked).length;
			}
		},
		mounted() {
			// 检查sessionStorage中是否有上传的文件
			this.checkForUploadedFiles();
			this.currencySymbol = storage.getCurrencySymbol();
			// 添加滚动事件监听
			window.addEventListener('scroll', this.handleScroll);
			// 在组件销毁时移除事件监听
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll);
				// 移除dialog-layout的滚动事件监听
				if (this.$refs.dialogLayout) {
					this.$refs.dialogLayout.removeEventListener('scroll', this.handleDialogScroll);
				}
			});
			// 初始计算match-table高度和检查定位状态
			this.$nextTick(() => {
				this.handleScroll();
			});
		},
		methods: {
			handleGoodsInfo(goods) {
				window.open('/product-detail?goodsId=' + goods.id);
			},
			//选择这个货源（返回商品索引）
			selectGoodsIndex(goodsIndex) {
				// 更新 selectImage 对象的 goodsIndex 属性
				this.selectImage.goodsIndex = goodsIndex;
				this.selectGoods = this.selectImage.goodsList[goodsIndex];

				// 同步更新 uploadedImages 中对应的元素
				this.uploadedImages.forEach(element => {
					if (element.key === this.selectImage.key) {
						element.goodsIndex = goodsIndex;
						element.goods = this.selectImage.goodsList[goodsIndex];
					}
				});
				this.$message.success(this.$t('selectSuccess'))
				// 强制更新视图
				this.$forceUpdate();
			},
			// 触发文件选择
			triggerFileInput() {
				this.$refs.fileInput.click();
			},
			// 处理文件上传
			handleFileUpload(event) {
				const files = event.target.files;
				if (files.length > 0) {
					// 处理文件并添加到上传列表
					this.addFilesToUploadList(files);
				}
			},
			async showMore(row) {
				console.log("selectImage===", row);
				row.goodsIndex = row.goodsIndex || 0;
				console.log(row.goodsIndex)
				this.selectImage = row;
				this.selectGoods = this.selectImage.goodsList[row.goodsIndex];
				this.showMoreProduct = true;
				this.selectImage.newBase64 = await generateThumbnail(row.region, row.url);
				this.selectImage.isSetting = this.selectImage.newBase64 != '';
				// 生成小图片
				this.generateSmallImages();
				setTimeout(() => {
					//加载查询条件
					if (this.$refs.productSearchFilter && typeof this.$refs.productSearchFilter.init ===
						'function') {
						this.$refs.productSearchFilter.init();
					}
					// 为dialog-layout添加滚动事件监听
					if (this.$refs.dialogLayout) {
						// 先移除可能存在的监听器，避免重复添加
						this.$refs.dialogLayout.removeEventListener('scroll', this.handleDialogScroll);
						// 添加新的监听器
						this.$refs.dialogLayout.addEventListener('scroll', this.handleDialogScroll);
						console.log("已为dialog-layout添加滚动事件监听");
					}
				}, 200)
			},
			handleScroll() {
				const matchTable = document.querySelector('.match-table');

				if (matchTable) {
					// 获取元素位置信息
					const tableRect = matchTable.getBoundingClientRect();

					// 计算页面底部位置
					const pageBottom = window.innerHeight;

					// 检查match-table是否完全可见
					// 当表格的底部小于等于页面底部时，表示表格已经完全显示
					const isTableFullyVisible = tableRect.bottom + 100 <= pageBottom;

					// 设置sticky定位状态：当表格未完全可见时，submit-layout悬浮在底部；否则取消悬浮
					this.isSubmitSticky = !isTableFullyVisible;
				}
			},
			handleSelectAll(val) {
				this.uploadedImages.forEach(item => {
					item.checked = val;
				});
			},
			// 检查sessionStorage中是否有上传的文件
			checkForUploadedFiles() {
				const uploadedFiles = sessionStorage.getItem('uploadedFiles');
				if (uploadedFiles) {
					try {
						const fileDataArray = JSON.parse(uploadedFiles);
						if (fileDataArray && fileDataArray.length > 0) {
							// 处理文件数据
							this.processUploadedFiles(fileDataArray);
							// 清除sessionStorage中的文件数据
							sessionStorage.removeItem('uploadedFiles');
						}
					} catch (error) {
						console.error('处理上传文件失败:', error);
						sessionStorage.removeItem('uploadedFiles');
					}
				}
			},
			// 添加文件到上传列表
			addFilesToUploadList(files) {
				// 计算剩余可上传数量
				const remainingSlots = this.maxImages - this.uploadedImages.length;
				if (remainingSlots <= 0) {
					// 已达到最大数量限制
					var tip = this.$t('maxUpload');
					this.$message.warning(tip.replace('{max}', this.maxImages));
					return;
				}

				// 限制上传数量
				const filesToAdd = Math.min(files.length, remainingSlots);

				// 处理每个文件
				for (let i = 0; i < filesToAdd; i++) {
					const file = files[i];
					// 创建文件URL用于预览
					const imageUrl = URL.createObjectURL(file);

					// 创建一个临时对象，先添加到数组
					const imageItem = {
						key: Math.floor(Math.random() * 10000000000),
						loadingStatus: 'waiting', //waiting等待搜索，searching搜索中，completed搜索完成，failed搜索失败
						checked: false,
						url: imageUrl,
						file: file,
						name: file.name,
						size: file.size,
						type: file.type,
						base64: '', //原图base64
						newBase64: '', //存储搜索区域返回的base64
						isSetting: false //是否设置过搜索区域
					};
					this.uploadedImages.push(imageItem);

					// 转换文件为base64
					this.convertToBase64(file, (base64Data) => {
						// 更新base64数据
						imageItem.base64 = base64Data;
					});
				}

				if (filesToAdd < files.length) {
					var tip = this.$t('hasUpload');
					tip = tip.replace('{filesToAdd}', filesToAdd).replace('{max}', this.maxImages)
					this.$message.warning(tip);
				}

				// 处理选中状态和搜索
				this.processAfterFileAdd();
				console.log("图片数组", this.uploadedImages);
			},
			// 处理从sessionStorage获取的文件数据
			processUploadedFiles(fileDataArray) {
				// 计算剩余可上传数量
				const remainingSlots = this.maxImages - this.uploadedImages.length;
				if (remainingSlots <= 0) {
					// 已达到最大数量限制
					var tip = this.$t('maxUpload');
					this.$message.warning(tip.replace('{max}', this.maxImages));
					return;
				}

				// 限制上传数量
				const filesToAdd = Math.min(fileDataArray.length, remainingSlots);

				// 处理每个文件
				for (let i = 0; i < filesToAdd; i++) {
					const fileData = fileDataArray[i];

					// 创建一个临时对象，先添加到数组
					const imageItem = {
						key: Math.floor(Math.random() * 10000000000),
						loadingStatus: 'waiting', //waiting等待搜索，searching搜索中，completed搜索完成，failed搜索失败
						checked: false,
						url: fileData.url,
						name: fileData.name,
						size: fileData.size,
						type: fileData.type,
						base64: '', //原图base64
						newBase64: '', //存储搜索区域返回的base64
						isSetting: false //是否设置过搜索区域
					};
					this.uploadedImages.push(imageItem);

					// 将文件转换为base64
					this.convertBlobUrlToBase64(fileData.url, (base64Data) => {
						// 更新base64数据
						imageItem.base64 = base64Data;
					});
				}

				if (filesToAdd < fileDataArray.length) {
					var tip = this.$t('hasUpload');
					tip = tip.replace('{filesToAdd}', filesToAdd).replace('{max}', this.maxImages)
				}

				// 处理选中状态和搜索
				this.processAfterFileAdd();
				console.log("从Home页面上传的图片数组", this.uploadedImages);
			},
			// 文件添加后处理
			processAfterFileAdd() {
				// 更新上传图片数量
				this.uploadedImagesCount = this.uploadedImages.length;
				// 默认加载loadingStatus='waiting'的数据
				this.searchGoods();
			},
			// 将文件转换为base64
			convertToBase64(file, callback) {
				const reader = new FileReader();
				reader.onload = (e) => {
					const base64Data = e.target.result;
					if (callback) {
						callback(base64Data);
					}
				};
				reader.onerror = (error) => {
					console.error('转换失败:', error);
					if (callback) {
						callback('');
					}
				};
				reader.readAsDataURL(file);
			},
			// 将blob URL转换为base64格式
			convertBlobUrlToBase64(blobUrl, callback) {
				fetch(blobUrl)
					.then(response => response.blob())
					.then(blob => {
						const reader = new FileReader();
						reader.onload = (e) => {
							const base64Data = e.target.result;
							if (callback) {
								callback(base64Data);
							}
						};
						reader.onerror = (error) => {
							console.error('转换失败:', error);
							if (callback) {
								callback('');
							}
						};
						reader.readAsDataURL(blob);
					})
					.catch(error => {
						console.error('获取blob失败:', error);
						if (callback) {
							callback('');
						}
					});
			},
			// 设置图片搜索区域
			setManualSelect(image) {
				console.log("设置图片搜索区域", image);
				this.selectImage = image;
				this.dialogVisible = true;
			},
			// 处理选择确认
			handleSelectionConfirm(selectionData) {
				this.uploadedImages.forEach(element => {
					if (selectionData.key == element.key) {
						element.pageNumber = 1;
						element.region = selectionData.region;
						element.isSetting = true;
						element.newBase64 = selectionData.imageWithSelectionBase64;
						element.loadingStatus = 'waiting'; // 设置为等待搜索状态
						element.goodsList = [];
						this.selectImage = element;
						this.selectImage = JSON.parse(JSON.stringify(this.selectImage))
					}
				});

				this.uploadedImages = JSON.parse(JSON.stringify(this.uploadedImages));

				this.dialogVisible = false;
				// 开始搜索
				this.searchGoods();
				// 这里可以使用选择区域数据进行后续操作
			},
			// 处理选择取消
			handleSelectionCancel() {
				this.dialogVisible = false;
			},
			// 优化后的搜索方法（串行请求）
			async searchGoods() {
				// 检查是否已有搜索流程在运行
				if (this.isSearching) return;

				// 过滤出需要搜索的图片（状态为waiting）
				const imagesToSearch = this.uploadedImages.filter(image => image.loadingStatus === 'waiting');
				if (imagesToSearch.length > 0) {
					// 标记搜索流程开始
					this.isSearching = true;
					this.searchStatus = 'searching';
					// 开始串行搜索
					await this.searchImagesSequentially(imagesToSearch, 0);
					// 所有图片搜索完成，标记搜索流程结束
					this.isSearching = false;
					this.searchStatus = 'finish';
				}
			},
			// 串行搜索图片
			async searchImagesSequentially(images, index) {
				if (index > 0) {
					this.searchStatus = 'finish';
				}
				if (index >= images.length) return;

				const image = images[index];
				// 更新状态为搜索中
				image.loadingStatus = 'searching';
				// 如果当前搜索的图片是用户选中的图片，则同步更新 selectImage 的 loadingStatus
				if (this.selectImage && this.selectImage.key === image.key) {
					this.selectImage.loadingStatus = 'searching';
				}

				try {
					// 执行搜索
					const result = await this.searchGoodsByImage(image);
					// 更新状态为完成
					image.loadingStatus = 'completed';
					// 将搜索结果存储到searchResults对象中，使用key作为唯一键值
					this.searchResults[image.key] = result;
					image.multiRegion = result.result.picInfo.multiRegion;
					image.region = result.result.picInfo.region;
					if (result.result.goodsPage.total > 0) {
						image.goods = result.result.goodsPage.records[0];
						image.goodsList = result.result.goodsPage.records;
						// 如果当前搜索的图片是用户选中的图片，则同步更新 selectImage
						if (this.selectImage && this.selectImage.key === image.key) {
							this.selectImage.goodsIndex = 0
							this.selectImage.loadingStatus = 'completed';
							this.selectImage.goods = image.goods;
							this.selectImage.goodsList = image.goodsList;
							this.selectGoods = image.goods;
							this.selectImage.multiRegion = image.multiRegion;
							this.selectImage.region = image.region;
							this.selectImage.newBase64 = await generateThumbnail(image.region, image.url);
							this.generateSmallImages();
						}
					}
					this.$forceUpdate();
				} catch (error) {
					// 更新状态为失败
					image.loadingStatus = 'failed';
					// 如果当前搜索的图片是用户选中的图片，则同步更新 selectImage 的 loadingStatus
					if (this.selectImage && this.selectImage.key === image.key) {
						this.selectImage.loadingStatus = 'failed';
					}
					console.error('搜索失败:', error);
				}

				// 搜索下一张图片
				await this.searchImagesSequentially(images, index + 1);
			},
			// 根据图片搜索商品
			async searchGoodsByImage(image) {
				// 模拟网络请求延迟
				await new Promise(resolve => setTimeout(resolve, 1000));
				var data = {
					region: image.region || '',
					pageNumber: 1,
					pageSize: 20,
					imageBase64: image.base64,
				};

				// 执行以图搜索查询
				const res = await goodsApi.getGoodsByImage(data);
				return res;
			},
			//批量删除已选数据
			deleteSelectImage() {
				const checkedImages = this.uploadedImages.filter(item => item.checked);
				if (checkedImages.length === 0) {
					this.$message.warning(this.$t('deleteNotData'));
					return;
				}
				var confirmDelete = this.$t('confirmDelete').replace('{size}', checkedImages.length)
				this.$confirm(confirmDelete, this.$t('tip'), {
					confirmButtonText: this.$t('confirm'),
					cancelButtonText: this.$t('cancel'),
					type: 'warning'
				}).then(() => {
					checkedImages.forEach(image => {
						if (image.url) {
							URL.revokeObjectURL(image.url);
						}
						if (this.searchResults[image.key]) {
							delete this.searchResults[image.key];
						}
					});

					this.uploadedImages = this.uploadedImages.filter(item => !item.checked);

					if (this.uploadedImages.length === 0) {
						this.searchStatus = 'waiting';
						this.selectAll = false;
					}

					this.uploadedImagesCount = this.uploadedImages.length;

					this.$message.success(this.$t('deleteSuccess'));
				}).catch(() => {

				});
			},
			// 移除图片
			removeImage(key) {
				this.$confirm(this.$t('deleteOneIMage'), this.$t('tip'), {
					confirmButtonText: this.$t('confirm'),
					cancelButtonText: this.$t('cancel'),
					type: 'warning'
				}).then(() => {
					// 获取要删除的图片对象
					const removedImage = this.uploadedImages.find(item => item.key === key);
					if (!removedImage) {
						return;
					}
					// 获取图片对象在数组中的索引
					const index = this.uploadedImages.findIndex(item => item.key === key);
					if (index === -1) {
						return;
					}
					// 释放URL对象
					if (removedImage.url) {
						URL.revokeObjectURL(removedImage.url);
					}
					// 从数组中移除
					this.uploadedImages.splice(index, 1);
					if (this.uploadedImages.length == 0) {
						this.searchStatus = 'waiting';
					}
					// 从searchResults中移除对应的搜索结果
					if (this.searchResults[key]) {
						delete this.searchResults[key];
					}
					this.selectImage = {};
					this.showMoreProduct = false;
					// 移除dialog-layout的滚动事件监听
					if (this.$refs.dialogLayout) {
						this.$refs.dialogLayout.removeEventListener('scroll', this.handleDialogScroll);
					}
					this.$message.success(this.$t('deleteSuccess'));
					// 清空小图片列表
					this.smallImageList = [];
					// 更新上传图片数量
					this.uploadedImagesCount = this.uploadedImages.length;
				})
			},
			// 处理dialog-layout的滚动事件
			handleDialogScroll() {
				const dialogLayout = this.$refs.dialogLayout;
				if (!dialogLayout || !this.selectImage) return;

				const scrollTop = dialogLayout.scrollTop;
				const scrollHeight = dialogLayout.scrollHeight;
				const clientHeight = dialogLayout.clientHeight;
				// 当滚动到底部时，触发加载更多
				if (scrollHeight - scrollTop - clientHeight < 130) {
					this.loadingMore = true;
					this.loadMore();
				}
			},
			handleTop() {
				if (this.$refs.dialogLayout) {
					const dialogLayout = this.$refs.dialogLayout;
					const currentScrollTop = dialogLayout.scrollTop;
					if (currentScrollTop === 0) return;
					// 计算动画时间，根据滚动距离动态调整，最小300ms，最大1000ms
					const duration = Math.min(Math.max(currentScrollTop * 0.5, 300), 1000);
					const startTime = performance.now();
					// 使用requestAnimationFrame实现平滑滚动动画
					const animateScroll = (timestamp) => {
						const elapsed = timestamp - startTime;
						const progress = Math.min(elapsed / duration, 1);
						// 使用缓动函数，让滚动效果更自然
						const easeOutQuad = 1 - (1 - progress) * (1 - progress);
						// 计算当前应该滚动到的位置
						const newScrollTop = currentScrollTop - (currentScrollTop * easeOutQuad);
						// 设置滚动位置
						dialogLayout.scrollTop = newScrollTop;
						// 如果动画未完成，继续下一帧
						if (progress < 1) {
							requestAnimationFrame(animateScroll);
						} else {
							// 确保最终滚动到顶部
							dialogLayout.scrollTop = 0;
						}
					};
					// 开始动画
					requestAnimationFrame(animateScroll);
				}
			},
			handleClose() {
				// 先将dialogLayout滚动到顶部
				if (this.$refs.dialogLayout) {
					this.$refs.dialogLayout.scrollTop = 0;
				}
				// 移除dialog-layout的滚动事件监听
				if (this.$refs.dialogLayout) {
					this.$refs.dialogLayout.removeEventListener('scroll', this.handleDialogScroll);
				}
				// 清空小图片列表
				this.smallImageList = [];
				this.showMoreProduct = false;
			},
			// 加载更多数据
			async loadMore() {
				// 防止重复加载
				if (this.selectImage && this.selectImage.isLoading) {
					return;
				}

				try {
					console.log("触发下一页机制")
					// 检查是否有选中的图片
					if (!this.selectImage) return;

					// 设置加载状态
					this.selectImage.isLoading = true;

					// 增加页码
					const currentPage = (this.selectImage.pageNumber || 1) + 1;
					this.selectImage.pageNumber = currentPage;
					console.log("加载更多，页码:", currentPage);

					// 构造搜索参数
					var data = {
						region: this.selectImage.region || '',
						pageNumber: currentPage,
						pageSize: 20,
						imageBase64: this.selectImage.base64,
					};

					// 执行搜索，获取下一页数据
					const res = await goodsApi.getGoodsByImage(data);
					this.loadingMore = false;
					// 检查搜索结果是否有效
					if (!res || !res.result || !res.result.goodsPage || !res.result.goodsPage.records) {
						console.error('搜索结果格式错误:', res);
						return;
					}

					// 获取新的商品列表
					const newGoodsList = res.result.goodsPage.records;

					// 合并商品列表
					if (this.selectImage.goodsList && Array.isArray(this.selectImage.goodsList)) {
						this.selectImage.goodsList = [...this.selectImage.goodsList, ...newGoodsList];
					} else {
						this.selectImage.goodsList = newGoodsList;
					}

					// 更新uploadedImages中对应图片的商品列表
					this.uploadedImages.forEach(image => {
						if (image.key === this.selectImage.key) {
							image.goodsList = this.selectImage.goodsList;
							image.pageNumber = currentPage;
							image.isLoading = false;
						}
					});

					// 强制更新视图
					this.$forceUpdate();
				} catch (error) {
					console.error('加载更多数据失败:', error);
					// 出错时也要设置加载状态为false
					if (this.selectImage) {
						this.selectImage.isLoading = false;
						// 更新uploadedImages中对应图片的加载状态
						this.uploadedImages.forEach(image => {
							if (image.key === this.selectImage.key) {
								image.isLoading = false;
							}
						});
					}
				} finally {
					// 无论成功失败，都设置加载状态为false
					if (this.selectImage) {
						this.selectImage.isLoading = false;
					}
				}
			},
			// 生成小图片
			async generateSmallImages() {
				const smallImages = await generateSmallImages(this.selectImage);
				this.smallImageList = smallImages;
				if (this.smallImageList.length > 0) {
					this.smallImageList[0].checked = true;
				}
			},
			//小图的选中事件
			handleSmallImage(row) {
				this.smallImageList.map(item => {
					item.checked = false;
				})
				row.checked = true;
				this.handleSelectionConfirm({
					key: row.key,
					region: row.region,
					imageWithSelectionBase64: row.base64
				})
			},
		}
	}
</script>

<style scoped>
	.dialog-top {
		cursor: pointer;
		position: absolute;
		z-index: 9999999;
		background: rgba(0, 0, 0, 0.35);
		bottom: 40px;
		right: 25px;
		width: 55px;
		height: 55px;
		border-radius: 100px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		color: #fff;
		font-weight: bold;
	}

	.small-image-container {
		display: flex;
		align-items: flex-end;
	}

	.small-image-item {
		margin-left: 10px;
		cursor: pointer;
	}

	/* Upload section styles */
	.upload-section {
		margin-top: 20px;
		margin-bottom: 20px;
		display: flex;
		align-items: center;
		gap: 15px;
	}

	/* Match item loading styles */
	.match-item .nodata {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 200px;
		position: relative;
	}

	/* Waiting state animation */
	.match-item .nodata.waiting {
		color: #606266;
	}

	.loading-spinner {
		width: 40px;
		height: 40px;
		border: 3px solid #f3f3f3;
		border-top: 3px solid #D9001B;
		border-radius: 50%;
		animation: spin 1s linear infinite;
		margin-bottom: 15px;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}

	/* Searching state animation */
	.match-item .nodata.searching {
		color: #D9001B;
	}

	.scanning-container {
		position: relative;
		width: 100px;
		height: 100px;
		margin-bottom: 15px;
		overflow: hidden;
	}

	.scan-line {
		position: absolute;
		top: -20px;
		left: 0;
		width: 100%;
		height: 3px;
		background-color: #D9001B;
		animation: scan 2s ease-in-out infinite;
		box-shadow: 0 0 10px 2px rgba(217, 0, 27, 0.5);
	}

	@keyframes scan {
		0% {
			top: -20px;
		}

		50% {
			top: 100%;
		}

		100% {
			top: -20px;
		}
	}

	/* 请等待搜索结果动画 */
	.match-item.loading {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.loading-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #606266;
	}

	.upload-button {
		position: relative;
	}

	.custom-upload-btn {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 15px 25px;
		background-color: #D9001B;
		color: white;
		border: none;
		border-radius: 5px;
		cursor: pointer;
		font-size: 16px;
		transition: background-color 0.3s;
	}

	.custom-upload-btn:hover {
		background-color: #f78989;
	}

	.file-input {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
		z-index: 1;
	}

	.upload-tip {
		font-size: 14px;
		color: #666;
	}

	/* Uploaded images styles */
	.uploaded-images {
		display: flex;
		gap: 15px;
		flex-wrap: wrap;
		margin-bottom: 20px;
	}

	.uploaded-image-item {
		position: relative;
		width: 150px;
		height: 150px;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		overflow: hidden;
		background-color: #fff;
	}

	.uploaded-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 8px;
		cursor: pointer;
	}

	.manual-select {
		position: absolute;
		width: 150px;
		background-color: #016AF8;
		color: #fff;
		font-size: 15px;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 5px 0;
		cursor: pointer;
	}

	.remove-image-btn {
		position: absolute;
		top: 0;
		right: 0;
		background-color: #D9001B;
		color: white;
		border: none;
		width: 22px;
		height: 22px;
		border-radius: 0 0 0 4px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		z-index: 1;
	}

	/* 搜索状态遮罩层 */
	.search-mask {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 5;
	}

	.search-mask.waiting {
		background-color: rgba(0, 0, 0, 0.35);
	}

	.search-mask.searching {
		background-color: rgba(245, 154, 35, 0.5);
		overflow: hidden;
	}

	/* 扫描线效果 */
	.scan-line {
		position: absolute;
		left: 0;
		width: 100%;
		height: 3px;
		background: linear-gradient(to right, transparent, #fff, transparent);
		box-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
		animation: scan 2s ease-in-out infinite;
		z-index: 6;
	}

	@keyframes scan {
		0% {
			top: 0;
		}

		50% {
			top: 100%;
		}

		100% {
			top: 0;
		}
	}

	.search-mask-content {
		color: white;
		font-size: 14px;
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.search-mask-content .el-icon-loading {
		animation: rotate 1s linear infinite;
	}

	@keyframes rotate {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}

	.upload-tip {
		font-size: 14px;
		color: #666;
	}

	.upload-tip span {
		font-size: 16px;
		font-weight: bold;
		color: #333;
	}

	/* Filter container styles */
	.filter-container {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		justify-content: space-between;
		margin: 20px 0;
	}

	.filter-container.filter-container-fixed {
		position: fixed !important;
		top: 40px !important;
		left: 0 !important;
		right: 0 !important;
		bottom: auto !important;
		z-index: 999 !important;
		background-color: #f2f2f2;
		padding: 15px 20px;
		justify-content: center;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
	}

	.filter-item {
		display: flex;
		flex-direction: column;
		gap: 5px;
		border: 1px solid #DCDFE6 !important;
		background: #F2F2F2;
		border-radius: 5px;
	}

	.filter-item label {
		font-weight: bold;
		font-size: 14px;
		color: #333;
	}

	.filter-select {
		width: 200px;
	}

	:deep .custom-dialog {
		height: 100vh;
		/* 固定高度 */
		overflow: hidden;
	}

	.upload-btn {
		background-color: #D9001B;
		border-color: #D9001B;
		padding: 15px 25px;
		font-size: 16px;
	}

	.add-cart-btn {
		padding: 15px 25px;
		font-size: 16px;
	}

	.view-all-btn {
		background-color: #F4E1E9;
		border-color: #F4E1E9;
		color: #D9001B;
		font-weight: bold;
	}

	.product-page {
		padding: 0;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
	}

	.match-table {
		margin-top: 20px;
		width: 100%;
		border-collapse: collapse;
		background-color: white;
	}

	.match-table th,
	.match-table td {
		border: 1px solid #E4E7ED;
		padding: 15px;
		text-align: left;
	}

	.match-table th {
		background-color: #F5F7FA;
		font-weight: bold;
		color: #606266;
	}

	.checkbox-col {
		width: 50px;
		text-align: center;
	}

	.index-col {
		width: 100px;
		text-align: center;
	}

	.upload-image-col {
		width: 200px;
	}

	.uploaded-image-container {
		width: 150px;
		height: 150px;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	.uploaded-image {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
	}

	.match-result-col {
		width: calc(100% - 330px);
	}

	.match-item {
		background-color: #F8F8F8;
		border-radius: 5px;
		padding: 10px 15px 15px 15px;
	}

	.match-header {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.match-label {
		font-size: 14px;
		color: #606266;
		padding: 0 10px 0 5px;
		font-weight: bold;
	}

	.match-content {
		display: flex;
		gap: 15px;
		cursor: pointer;
	}

	.match-content-selected {
		background-image: linear-gradient(to right, #DDEAFF, #fff);
		padding: 10px 0;
		margin-top: 10px;
	}

	.nowed-selected {
		font-size: 16px;
		color: #D9001B;
		display: flex;
		align-items: center;
		padding-left: 15px;
		font-weight: bold;
	}

	.match-image-container {
		width: 100px;
		height: 100px;
		overflow: hidden;
	}

	.match-image {
		width: 100%;
		height: 100%;
		object-fit: contain;
		border-radius: 10px;
	}

	.match-info {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.vip-tag {
		display: flex;
		align-items: center;
		gap: 5px;
		color: #F59A23;
		font-size: 12px;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.vip-tag-left {
		display: flex;
		background-color: #FEF5E9;
		padding: 5px 10px;
		border-radius: 5px;
	}

	.store-name {
		font-size: 14px;
		color: #606266;
		font-weight: normal;
	}

	.product-name {
		font-size: 15px;
		color: #303133;
		font-weight: bold;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		/* 限制行数为2 */
		-webkit-box-orient: vertical;
		overflow: hidden;

	}

	.product-price {
		font-size: 18px;
		color: #F59A23;
		font-weight: bold;
	}

	/* Submit Layout Styles */
	.submit-layout {
		background-color: white;
		background: #F2F2F2;
		padding: 15px 20px;
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 15px;
		position: sticky;
		bottom: 0;
		max-width: 100%;
		z-index: 9;
	}

	.submit-layout-fixed {
		max-width: 1200px;
		padding: 15px 20px;
		margin-bottom: 20px;
	}

	.submit-left {
		flex: 1;
		display: flex;
		align-items: center;
		font-size: 15px;
		min-width: 200px;
	}

	.submit-right {
		flex: 1;
		min-width: 250px;
		display: flex;
		justify-content: flex-end;
		gap: 15px;
		color: #666;
	}

	.submit-sub-right {
		display: flex;
		flex-direction: column;
	}

	.btn-top-tip {
		font-size: 14px;
		margin-bottom: 5px;
	}

	.btn-top-tip span {
		font-size: 16px;
		font-weight: bold;
		color: #000;
	}

	::-webkit-scrollbar {
		width: 2px;
		height: 5px;
	}

	::-webkit-scrollbar-thumb {
		border-radius: 1em;
		background-color: rgba(50, 50, 50, .3);
	}

	::-webkit-scrollbar-track {
		border-radius: 1em;
		background-color: rgba(50, 50, 50, .1);
	}

	/* 加载中动画效果 */
	.loading-more {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}

	.loading-more .el-icon-loading {
		font-size: 24px;
		color: #666;
		animation: rotating 2s linear infinite;
	}

	.loading-more span {
		color: #999;
		font-size: 16px;
	}

	.dialog-layout {
		height: 88vh;
		overflow-y: auto;
		margin-top: -20px;
		padding-right: 15px;
		margin-right: -15px;
	}
</style>